// extracted by mini-css-extract-plugin
module.exports = {"container":"_3tMpF","button":"_3Jgih","actionsContainer":"_2f8hw","center":"_2UOgZ","right":"_1slCa","top":"_3NHJY","triangle":"_1QC2S","fixedColor":"_1WE1p"};